{
  "checkedInTitle": "Jesteś zameldowany",
  "postCheckInInstructions": "Instrukcje po zameldowaniu",
  "appointmentDetails": "Szczegóły wizyty",
  "notifyWarehouse": "Poinformowaliśmy magazyn o Twoim przybyciu, aby mogli sprawdzić swoją dostępność",
  "waitForStaff": "Proszę czekać na dalsze instrukcje od personelu magazynu",
  "unplannedDescription": "Wygląda na to, że nie masz umówionej wizyty. Proszę czekać na dalsze instrukcje od personelu magazynu.",
  "whatsappDelay": "Pierwsza wiadomość WhatsApp może dotrzeć z opóźnieniem do jednej minuty.",
  "bookNextTitle": "Zarezerwuj wizytę na następny raz",
  "bookNextBody": "Zarejestruj się w Opendock, aby zarezerwować wizytę następnym razem, gdy odwiedzisz ten obiekt",
  "helpFooter": "Jeśli potrzebujesz pomocy lub dodatkowych informacji, skontaktuj się z personelem magazynu",
  "finalize": "Zakończ ({seconds})"
}
